import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import statesWithRegions from './filters/statesWithRegions'
import measures from './filters/measures'
import { components } from '@datavue/datavue-ui'
const ChloroplethHeatmap = () =>
  import('../components/charts/ChloroplethHeatmap')
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')

export default class Trailering {
  title =
    'Trailering / Transporting Recreational Boats for the Purpose of Launching'
  key = 'trailering'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      filter1stateorregion: {
        label: 'State/Region of Registration or Storage:',
        component: components['DatavueUiSelect'],
        options: statesWithRegions
      },
      measure: {
        label: 'Display Results as:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: measures
      }
    }
  }
  charts = function () {
    return {
      state_of_outing_trailered: {
        title:
          'Operated Boats That Were Trailered At Least Once By State of Registration or Storage',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map',
          tableLabel: 'State of Registration or Storage',
          tableAdapter: tableAdapter
        }
      },
      region_of_outing_trailered: {
        title:
          'Operated Boats That Were Trailered At Least Once By Region of Registration or Storage',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'region',
          grid: 'map',
          tableLabel: 'Region of Registration or Storage',
          tableAdapter: tableAdapter
        }
      },
      state_of_outing_transported: {
        title:
          'Operated Boats That Were Transported At Least Once By State of Registration or Storage',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map2',
          tableLabel: 'State of Registration or Storage',
          tableAdapter: tableAdapter
        }
      },
      region_of_outing_transported: {
        title:
          'Operated Boats That Were Transported At Least Once By Region of Registration or Storage',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'region',
          grid: 'map2',
          tableLabel: 'Region of Registration or Storage',
          tableAdapter: tableAdapter
        }
      },
      boats_transported: {
        title: 'Operated Boats That Were Trailered/Transported At Least Once',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other'
        }
      },
      average_times_transported: {
        title: 'Times Operated Boats Were Trailered/Transported',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          average: true
        }
      }
    }
  }
}
